<template>
  <div class="auth-failure">
    <header class="auth-failure__header">
      <div class="auth-failure__header-container">
        <div class="auth-failure__logo-box">
          <div class="auth-failure__logo">
            <img src="../../assets/images/auth-page-logo.png" alt="lukoil" loading="lazy">
          </div>
          <div class="auth-failure__title">
            <h1>
              ЛУКМАРКЕТ / TEBOIL МАРКЕТ
            </h1>
          </div>
        </div>
        <div class="auth-failure__user-box">
          <div class="auth-failure__user">
            <div v-if="accountInfo.name" class="auth-failure__user-field">
              <div class="auth-failure__user-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_29_38)">
                    <path d="M8 8.79999C8 7.73912 8.42143 6.72171 9.17157 5.97156C9.92172 5.22142 10.9391 4.79999 12 4.79999C13.0609 4.79999 14.0783 5.22142 14.8284 5.97156C15.5786 6.72171 16 7.73912 16 8.79999C16 9.86085 15.5786 10.8783 14.8284 11.6284C14.0783 12.3786 13.0609 12.8 12 12.8C10.9391 12.8 9.92172 12.3786 9.17157 11.6284C8.42143 10.8783 8 9.86085 8 8.79999Z" fill="#A5A4A4"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0ZM1.6 12C1.60003 10.2795 2.02691 8.58584 2.84239 7.07085C3.65786 5.55586 4.83647 4.26686 6.27258 3.31934C7.70869 2.37183 9.35744 1.79541 11.0711 1.64173C12.7847 1.48805 14.5097 1.76193 16.0915 2.4388C17.6733 3.11568 19.0624 4.17442 20.1345 5.52014C21.2065 6.86586 21.9279 8.45652 22.234 10.1496C22.5402 11.8427 22.4215 13.5852 21.8886 15.2212C21.3558 16.8571 20.4254 18.3352 19.1808 19.5232C19.0614 18.1254 18.4216 16.8234 17.3882 15.8747C16.3547 14.926 15.0029 14.3997 13.6 14.4H10.4C8.99713 14.3997 7.64525 14.926 6.61181 15.8747C5.57837 16.8234 4.93864 18.1254 4.8192 19.5232C3.80028 18.5532 2.98942 17.386 2.43599 16.0926C1.88255 14.7993 1.59812 13.4068 1.6 12Z" fill="#A5A4A4"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_29_38">
                      <rect width="24" height="24" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <p>{{accountInfo.name}}</p>
            </div>
            <div v-if="accountInfo.email" class="auth-failure__user-field">
              <div class="auth-failure__user-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_29_43)">
                    <path d="M21.5531 4C21.4622 3.99064 21.3706 3.99064 21.2798 4H2.6131C2.49346 4.00185 2.37462 4.01979 2.25977 4.05334L11.8931 13.6467L21.5531 4Z" fill="#A5A4A4"/>
                    <path d="M22.54 4.92664L12.8333 14.5933C12.5835 14.8416 12.2455 14.981 11.8933 14.981C11.541 14.981 11.2031 14.8416 10.9533 14.5933L1.33329 4.99997C1.30371 5.10866 1.28803 5.22067 1.28662 5.3333V18.6666C1.28662 19.0203 1.4271 19.3594 1.67715 19.6094C1.92719 19.8595 2.26633 20 2.61995 20H21.2866C21.6402 20 21.9794 19.8595 22.2294 19.6094C22.4795 19.3594 22.62 19.0203 22.62 18.6666V5.3333C22.6146 5.19441 22.5877 5.05719 22.54 4.92664ZM3.53329 18.6666H2.60662V17.7133L7.45329 12.9066L8.39329 13.8466L3.53329 18.6666ZM21.2733 18.6666H20.34L15.48 13.8466L16.42 12.9066L21.2666 17.7133L21.2733 18.6666Z" fill="#A5A4A4"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_29_43">
                      <rect width="24" height="24" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <p>{{accountInfo.email}}</p>
            </div>
          </div>
          <div class="auth-failure__header-action">
            <button class="auth-failure__button auth-failure__button--isHiddenMobile" @click="logout">
              Выйти
            </button>
            <button class="auth-failure__iconButton auth-failure__iconButton--isHiddenTablet" @click="logout">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.33301 1.33325H10.6663V2.66659H2.66634V17.3333H10.6663V18.6666H1.33301V1.33325ZM14.4717 5.52792L18.925 9.98125L14.489 14.7853L13.5103 13.8813L16.477 10.6666H5.33301V9.33325H16.3903L13.5277 6.47192L14.4717 5.52792Z" fill="#A5A4A4"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>
    <main class="auth-failure__main">
      <div class="auth-failure__content-box">
        <div  class="auth-failure__text">
          <slot name="textSlot" />
        </div>
        <div class="auth-failure__action">
          <button class="auth-failure__button auth-failure__button--isUppercase" @click="logout">
            Выход
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "AuthFailure",
    computed: {
      ...mapGetters("account", ["accountInfo"]),
    },
    methods: {
      ...mapActions("account", ["logout"]),
    },
}
</script>

<style scoped lang="sass">
@import "../../assets/sass/components/auth-failure.sass";
</style>
